const CLOSE_DELAY_MS = 400;

type FlowbiteDropdown = { hide?: () => void };
type FlowbiteInstancesGlobal = {
    getInstance?: (type: string, id: string) => FlowbiteDropdown | null;
};

const getFlowbiteInstances = (): FlowbiteInstancesGlobal | undefined => {
    return (window as unknown as { FlowbiteInstances?: FlowbiteInstancesGlobal }).FlowbiteInstances;
};

const hideDropdown = (id: string): void => {
    const instance = getFlowbiteInstances()?.getInstance?.('Dropdown', id);
    instance?.hide?.();
};

const hideAllOpenNavDropdowns = (): void => {
    document.querySelectorAll<HTMLElement>('[id^="dropdown-"]:not(.hidden)').forEach((el) => {
        hideDropdown(el.id);
    });
};

export const initNavDropdownAutoClose = (): void => {
    const mainMenu = document.getElementById('main-menu');
    if (!mainMenu) return;

    mainMenu.querySelectorAll<HTMLElement>('[data-dropdown-toggle]').forEach((trigger) => {
        const dropdownId = trigger.getAttribute('data-dropdown-toggle');
        if (!dropdownId) return;
        const dropdown = document.getElementById(dropdownId);
        if (!dropdown) return;

        let closeTimer: number | null = null;

        const cancelClose = (): void => {
            if (closeTimer !== null) {
                clearTimeout(closeTimer);
                closeTimer = null;
            }
        };

        const scheduleClose = (): void => {
            cancelClose();
            closeTimer = window.setTimeout(() => {
                hideDropdown(dropdownId);
                closeTimer = null;
            }, CLOSE_DELAY_MS);
        };

        trigger.addEventListener('mouseenter', cancelClose);
        trigger.addEventListener('mouseleave', scheduleClose);
        dropdown.addEventListener('mouseenter', cancelClose);
        dropdown.addEventListener('mouseleave', scheduleClose);
    });

    window.addEventListener('scroll', hideAllOpenNavDropdowns, { passive: true });
};
